import logo from "../../../logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../i18n/useTranslation";

const Copyright = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 pb-6 px-5">
      <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "auto" })}>
        <img alt="Tapaswe Global" src={logo} width="48" height="48" />
      </Link>
      <div className="font-mono text-xs tracking-[0.04em] opacity-75 text-center">
        {t("footer.copyright")}
      </div>
    </div>
  );
};

export default Copyright;
